module.exports = __webpack_public_path__ + "media/categories/4014-d2914c73.svg";